/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 * Instantiate Micromodal and configure defaults across modal components.
 * - https://micromodal.now.sh/#configuration
 *
 * @namespace Modal
 */
import MicroModal from 'micromodal';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

import {extendDefaults} from '../helpers/utils';

/**
 * Create a new modal object.
 * @param {object} config - Settings for modal instance.
 */
export default (selector, config) => {

  /**
   * Instance default settings.
   */
  const defaults = {
    onClose: () => {
      enableBodyScroll(document.querySelector('.modal__card'));
    },
  };

  /**
   * Instance settings.
   */
  const settings = extendDefaults(defaults, config);

  /**
   * Instantiate a new modal.
   */
  function init() {
    MicroModal.init(selector, settings);
  }

  /**
   * Show modal with default settings.
   */
  function show() {
    disableBodyScroll(document.querySelector(`#${selector} .modal__card`));
    MicroModal.show(selector, settings);
  }

  /**
   * Close modal with default settings.
   */
  function close() {
    enableBodyScroll(document.querySelector(`#${selector} .modal__card`));
    MicroModal.close(selector, settings);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
    show,
    close,
  });
};
